import { ActionIcon, Avatar, Badge, Button, Loader, Menu, Modal, MultiSelect, NumberInput, SegmentedControl, Tooltip } from '@mantine/core';
import 'keen-slider/keen-slider.min.css';
import { res_get_me, WEEK, getLastMonday, YYYYMMDD_AEDT, getMondays, quarterToDates, rangeQuarter, getCurrentQuarter, getQuarters } from '../../../src/types'; /// SHARED
import '../ratpack-ui/src/app/AppImports';
import { Select } from '../ratpack-ui/src/components/Select/Select';
import { Text } from '../ratpack-ui/src/components/Text/Text';
import { AdminPageLayout } from '../ratpack-ui/src/pages/AdminPageLayout';
import '../ratpack-ui/src/styles/Font.css';
import * as React from 'react';
import { useState } from 'react';
import { atom, selector, useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { GET, POST } from '../api';
import { MustLogIn } from '../session';
import { dollar } from '../util';
import { adminDefaults, hotPink } from './components';
import { ErrorBoundary, unionBy } from './PaymentsPage';
import { AiOutlineArrowRight, AiOutlineCloudUpload } from "react-icons/ai";
import { useBlocker, BlockerFunction } from 'react-router-dom';
import { Anchor } from '../ratpack-ui/src/components/Anchor/Anchor';

const teamAtom = atom<Agents>({
    key: 'team',
    default: {agents:[]},
})

const sortAgents = (agents:Agent[])=>{
    return agents.sort((a,b)=>{
        const byName = a.name.localeCompare(b.name)
        const role = a => ({
            "admin": 1,
            "manager": 2,
            "agent": 3,
        }[getAgentType(a)]??0)
        const byRole = (role(a)-role(b)) * 10
        console.log({byName,byRole})
        return byName + byRole
    })
}

const toggleKey = (key:string) => (value:boolean=null) => (obj:{}) => ({...obj, [key]: value ?? !obj[key]})

type Agent = any
type Agents = {agents:Agent[]}
const useTeam = () => {
    const [isLoading, setIsLoading] = useState(true)
    const [isUploading, setIsUploading] = useState({} as Record<email,boolean>)
    const [error, setError] = useState(null)
    const [team, setTeam] = useRecoilState(teamAtom)

    const updateTeam = async (force=false)=>{
        if(isLoading && !force) {
            setError(`Another request is in progress`)
            return
        }
        setIsLoading(true)
        await GET(`/api/team`).then(async res => {
            setTeam({agents:sortAgents(res?.agents)})
        }).then(()=>{
            setIsLoading(false)
            setError(null)
        }).catch(e=>{
            console.error(e)
            setError(e)
            setIsLoading(false)
        })
    }

    const updateAgent = async (agent) => {
        if(isLoading) {
            setError(`Another request is in progress`)
            return
        }
        setIsUploading(toggleKey(agent?.email)(true))
        await POST(`/api/team/${agent?.email}`, agent).then(res => {
            console.log({agents:team?.agents,res})
            setTeam(team => ({agents:sortAgents(unionBy(team?.agents,[res],'id'))}))
        }).then(()=>{
            setError(null)
        }).catch(e=>{
            console.error(e)
            setError(e)
        }).finally(()=>{
            setIsUploading(toggleKey(agent?.email)(false))
        })
    }

    const updateAgents = async (updates) => {
        await Promise.all((team?.agents??[]).map(agent => {
            const update = updates[agent?.email]??{}
            const updated = isUpdated(agent, update)
            if(!updated) return
            return updateAgent({...agent, ...(update??{})})
        }))
    }

    React.useEffect(()=>{
        updateTeam(true)
    },[])

    return { team, updateTeam, updateAgent, updateAgents, isLoading, error, isUploading }
}

export const getAgentType = (user:res_get_me, verbose=false):'admin'|'manager'|'agent'|string => {
    if(user.admin) return 'admin'
    if(user.manages?.length) return verbose ? `manager (${user.manages.join(', ')})` : 'manager'
    return 'agent'
}
export const getAgentTypeBadge = (user:res_get_me) => {
    const badge = (text="Admin",backgroundColor="#30CCFF") => (<Badge
        style={{backgroundColor}}
        size='sm'
        color={backgroundColor}
        variant="filled"
    >{text}</Badge>)
    if(user.admin) return badge("Admin", "#FF195E")
    if(user.manages?.length) return badge("Manager", "#679F38")
    return badge("Agent", "#30CCFF")
}

// function range(start, end, step = 1) {
//     const result = [];
//     for (let i = start; i <= end; i += step) result.push(i);
//     return result;
// }
const DAY = 24 * 3600e3

// const getQuarters = (start = 2025, end = new Date().getFullYear() + 1) =>
//     Array.from({ length: (end - start + 1) * 4 }, (_, i) => {
//         const year = start + Math.floor(i / 4);
//         const quarter = (i % 4) + 1;
//         return `${year}-Q${quarter}`;
//     });

// const getCurrentQuarter = () => {
//     const now = new Date();
//     const year = now.getFullYear();
//     const quarter = Math.floor(now.getMonth() / 3) + 1;
//     return `${year}-Q${quarter}`;
// };

// const quarterToDates = (q = getCurrentQuarter()) => {
//     const [year, qNum] = q?.split('-Q') ?? [];
//     const month = (parseInt(qNum) - 1) * 3;
//     return [
//         new Date(parseInt(year), month, 1),
//         new Date(parseInt(year), month + 3, 0)
//     ];
// };

// const rangeQuarter = (q: string):Array<number> => {
//     const [start, end] = quarterToDates(q)//.map(d=>d.getTime())
//     return getMondays(start, end).map(d => d.getTime())
//     // return range(start,end,DAY*7)
// }

type email = string
type unixTime = string
const commissionsAtom = atom<Record<email,Record<unixTime,number>>>({
    key: 'commissions',
    default: {},
})

const teamUpdatesAtom = atom<Record<email,Partial<Agent>>>({
    key: 'teamUpdates',
    default: {},
})

const sticky = {
    // left: '20px',
    // left: 0,
    // paddingLeft: '20px', // 50
    // backgroundColor: '#f5f5f5',
    position: 'sticky',
} as React.CSSProperties
const foldy = (expandDetails,width='auto') => ({
    width: expandDetails ? width : '0px',
    display: expandDetails ? 'table-cell' : 'none',
    transition: 'width 0.2s',
    overflow: 'hidden',
    minWidth: expandDetails ? width : '0',
    maxWidth: expandDetails ?'100%' : '0px',
} as React.CSSProperties)

const TeamOrganisationRow = ({agent, expandDetails, quarter, updateAgent, isUploading, isUpdated, updateTeam}) => {

    const allTeams = useRecoilValue(allTeamsAtom)
    const [updates, setUpdates] = useRecoilState(teamUpdatesAtom)
    const updateTeams = agent => teams => setUpdates(u=>({...u, [agent.email]:{...u[agent.email], teams:teams.sort((a,b)=>a.localeCompare(b)) }}))
    const updateManages = agent => manages => setUpdates(u=>({...u, [agent.email]:{...u[agent.email], manages:manages.sort((a,b)=>a.localeCompare(b)) }}))


    // const days = rangeQuarter(quarter) // range(min,max,DAY*7)

    const T = {teams:[], manages:[], ...agent, ...updates[agent?.email]}
    return (<>
        <td style={{ textAlign: 'center', ...sticky, borderRight: 'black solid 1px'}}>
            <Tooltip withinPortal position="top" withArrow zIndex={999} label={agent.email??agent.email}><div style={{
                  display: 'flex',
                  justifyContent: 'space-around',
            }}>
                {isUploading ? <Loader size="sm" color={hotPink} variant="oval"/> : <Avatar radius="md" size="sm" src={agent.avatar ?? agent.image_url} style={{margin: '0 15px'}}/>}
                {agent.name}
                {(isUpdated && !isUploading)? <ActionIcon
                    style={{ margin: '0 0 0 5px', color:isUploading?'gray':'black' }}
                    onClick={() => updateAgent({...agent, ...(updates?.[agent.email]??{})}).then(setUpdates(u=>({...u, [agent.email]: null})))}
                    disabled={isUploading}
                >                                    
                    <AiOutlineCloudUpload size={16} />
                </ActionIcon> : ''}
            </div></Tooltip>
        {/* </td><td style={{ textAlign: 'center', ...foldy(expandDetails)}}>
            {t.email??t.email} */}
        </td><td style={{ paddingLeft:'10px', textAlign: 'center', ...foldy(expandDetails), width:'260px'}}>
            <MultiSelect
                value={T.teams}
                onChange={updateTeams(agent)}
                placeholder='(none)'
                data={allTeams}
                // filter={(v,selected)=>!selected}
                creatable
                searchable
                getCreateLabel={(query) => `New team: ${query}`}
            />
        </td><td style={{ paddingLeft:'10px', textAlign: 'center', ...foldy(expandDetails), width:'260px'}}>
            <MultiSelect
                value={T.manages}
                onChange={updateManages(agent)}
                placeholder='(none)'
                data={allTeams}
                // filter={(v,selected)=>!selected}
                creatable
                searchable
                getCreateLabel={(query) => `New team: ${query}`}
            />
        </td><td style={{ paddingLeft:'10px', paddingRight:'10px', textAlign: 'center', borderRight: 'black solid 1px', ...foldy(expandDetails)}}>
            <div onClick={e=>{
                if(T.email?.startsWith('info@')) return
                const isAdmin = T.admin
                if(confirm(isAdmin ? `Remove ${T.email} from admins?` : `Make ${T.email} an admin?`)) GET(`/api/toggle_admin/${T.email}/${!isAdmin}`).then(()=>updateTeam())
            }}>{getAgentTypeBadge(T)}</div>
        {/* </td><td style={{ textAlign: 'center'}}>
            {t.quotes} */}
        </td>
    </>)
}

const NaNor = (n,nor=null) => isNaN(n) ? nor : n
const getTargetForDate = (agent, date) => {
    const exact = agent.targets[date]
    if(exact) return [exact, true] // specified date is set
    const closest = Object.keys(agent.targets).filter(D => D<=date).sort((b,a)=>parseInt(b)-parseInt(a)).at(-1)
    return [
        closest, // return a valid date to look up on agent.targets
        false, // is not exact
    ]
}

function useCommissions(quarter){
    const setCommissions = useSetRecoilState(commissionsAtom)
    React.useEffect(()=>{
        const get = () => GET(['/api/team/commission',quarter].filter(Boolean).join('/')).then(c=>setCommissions(c))
        const interval = setInterval(get, 30e3)
        const timeout = setTimeout(get, 1e3) // just to debounce first load
        // get()
        return ()=>{
            clearInterval(interval)
            clearTimeout(timeout)
        }
    },[quarter])
}
function useGetCommissions(){
    const commissions = useRecoilValue(commissionsAtom)
    const getCommission = (email:email, date:unixTime) => commissions?.[date]?.[email] ?? 0
    return {commissions, getCommission}
}
const CommissionLabel = ({email,date})=>{
    const {getCommission} = useGetCommissions()
    return <div>{dollar(getCommission(email,date))}</div>
}
// const unixToUTC = (d:number|Date) => {
//     const D = new Date(d)
//     return D.getTime() + D.getTimezoneOffset()*60e3
// }
const TeamTargetsRow = ({agent,startOfThisWeek,quarter}) => {

    const [updates, setUpdates] = useRecoilState(teamUpdatesAtom)
    // const isFuture = d => getLastMonday(d).getTime()>startOfThisWeek.getTime()
    const omitKey = (o,key) => {
        const {[key]:omit, ...rest} = o
        return rest
    }
    const updateTargets = agent => date => target => {
        console.log(`updateTargets`, {agent,date,target})
        setUpdates(u=>({
            ...u,
            [agent.email]:{
                ...u[agent.email],
                targets: ( isNaN(target) || (target === '') ) ? omitKey(u[agent.email]?.targets ?? agent.targets, date) : { ...(u[agent.email]??agent).targets, [date]: target*100 }
            }
        }))
    }

    const T = {targets:[], ...agent, ...updates[agent?.email]}
    const Q = rangeQuarter(quarter)
    return (<>
        {
            Q.map((d,i)=>{
                const [setOnDate,isSetOnThisDate] = getTargetForDate(T,d)
                const value = T.targets[setOnDate]
                return (<td key={i} style={{color:isSetOnThisDate?'black':'GrayText',paddingBottom:'5px'}}>
                    <div style={{margin:'0 10px'}}>
                        <NumberInput
                            label={<CommissionLabel date={d} email={agent?.email}/>}
                            styles={{
                                label: {
                                    fontSize: '0.75rem',
                                    color: 'gray',
                                }
                            }}
                            hideControls
                            value={NaNor(T.targets[d]/100,'')}
                            precision={2}
                            placeholder={((value??0)/100).toFixed(2)}
                            // onChange={updateTargets(agent)(d)}
                            onBlur={(event) => {
                                updateTargets(agent)(d)(event.currentTarget.value)
                            }}
                            // noClampOnBlur                            
                        />
                    </div>
                </td>)
            })
            // Object.entries(t.targets as Record<number,number>).map(([date,t],j)=>{
            //     return <td key={j} style={{ textAlign: 'center', overflowX: 'scroll'}}>${(t/100).toFixed(2)}</td>
            // })
        }
    </>)
}

const allTeamsAtom = selector({
    key: 'allTeams',
    get: ({get}) => {
        const team = get(teamAtom);
        const updates = get(teamUpdatesAtom);

        const userTeams = agent => [
            'Au-1',
            'Au-2',
            'Au-3',
            'Au-4',
            'Eu',
            ...(agent?.teams??[]),
            ...(agent?.manages??[]),
            ...(updates[agent?.email]?.teams??[]),
            ...(updates[agent?.email]?.manages??[]),
        ]
        const allTeams = Array.from(new Set(
            (team?.agents??[])
                .flatMap(a=>userTeams(a))
        )).map((t:string)=>({value:t,label:t})) as Array<{value:string,label:string}>
        return allTeams.sort(); // memoized
    },
  });

  const targetsSame = (a,b) => {
    const serialize = (o:Record<unixTime,string>) => Object.entries(o??{}).sort(([a],[b])=>a.localeCompare(b)).map(([k,v])=>[k,parseFloat(v)].join('=')).join('|')
    return serialize(a) == serialize(b)
}
const isUpdated = (
    agent,
    u, // =updates[agent?.email]??{},
) => Object.keys(u).length && (
    (agent.teams.join('|') !== (u.teams??agent.teams).join('|')) ||
    (agent.manages.join('|') !== (u.manages??agent.manages).join('|')) ||
    (!targetsSame(agent.targets,u.targets))
)

  function useBlockNavigationIfUpdates(team:Agents){
    const updates = useRecoilValue(teamUpdatesAtom);
    const isAnyUpdated = (team?.agents??[]).some(agent => isUpdated(agent, updates[agent?.email]??{}))
    const shouldBlock = React.useCallback<BlockerFunction>(({ currentLocation, nextLocation }) => isAnyUpdated && currentLocation.pathname !== nextLocation.pathname, [isAnyUpdated]);
    const blocker = useBlocker(shouldBlock);
    React.useEffect(() => { // for navigating via router
        if (blocker.state !== "blocked") return
        if (!isAnyUpdated) {
            blocker.reset();
            return
        }
        if(window.confirm('You have unsaved changes. Leave anyway?')) {
            blocker.proceed()
        } else {
            blocker.reset()
        }
    }, [blocker, isAnyUpdated]);
    React.useEffect(() => { // for navigating via link
        const handleBeforeUnload = (e:BeforeUnloadEvent) => {
            if(window.confirm('You have unsaved changes. Leave anyway?')) {
                return undefined; // navigate
            } else {
                e.preventDefault(); // abort
                e.returnValue = '';
                return '';    
            }
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
      }, []);
  }
export default () => {
    const { team, updateAgent, updateAgents, updateTeam, error, isLoading, isUploading } = useTeam()
    // const user = useRecoilValue(userAtom)
    const [expandDetails, setExpandDetails] = useState(false);
    
    // const [updates, setUpdates] = useRecoilState(teamUpdatesAtom)
    //useState<Record<email,Partial<Agent>>>({})
    
    const [quarter, setQuarter] = useState(getCurrentQuarter())
    useCommissions(quarter)


    const override = 
        (isLoading) ? <Text>Loading team data...</Text> :
        (!team) ? <Text>Error loading team data. Please try refreshing.</Text> : null

    const dates = team?.agents?.flatMap(a => Object.keys(a.targets)).map(d=>parseInt(d)).concat(
        getLastMonday(Date.now()-(7*DAY)).getTime(),
        getLastMonday(new Date()).getTime(),
        getLastMonday(Date.now()+(7*DAY)).getTime(),
    ) ?? []
    const min = Math.min(...dates)
    const max = Math.max(...dates)
    const days = rangeQuarter(quarter) // range(min,max,DAY*7)

    // useBlockNavigationIfUpdates(team) // WIP
    
    // React.useEffect(()=>{
    //     setTimeout(()=>{
    //         document.querySelector('#this-week')?.scrollIntoView({
    //             block: "nearest",
    //             inline: "center", // x only
    //         })
    //     }, 5000)
    //     // TODO: index sorted target dates in order to assist with finding the most recent one
    // },[team?.agents?.length])

    const startOfThisWeek = getLastMonday(new Date())
    const isThisWeek = d => {
        const sow = getLastMonday(d).getTime()
        const sotw = startOfThisWeek.getTime()
        console.log({d,sow,sotw})
        return sow==sotw
    }

    // TODO: pullUpdate overwrites all changes
    // TODO: sendUpdate will POST the clicked row's updates and clear the updates for that row
    // email => updateAgent({...agent, ...updates}).then(setUpdates(u=>({...u, [email]: null})))

    // TODO button to sync new users
    console.log('RENDER')

    const [updates,setUpdates] = useRecoilState(teamUpdatesAtom)
    const isUploadingAny = Object.values(isUploading).some(Boolean)
    const isUpdatedAny = (team?.agents??[]).some(agent => isUpdated(agent, updates[agent?.email]??{}))
    // Object.entries(updates).some(([email,agent])=>isUpdated((team?.agents??[]).find(agent => agent?.email == email), updates[agent?.email]??{}))

    return (<AdminPageLayout {...adminDefaults({ page: 'team' })} footer={[]} page={<>
        <MustLogIn />
        {override ?? <ErrorBoundary fallback={<p>Something went wrong while rendering the page</p>}>
            <div style={{
                width: '99vw',
                maxWidth: '99vw',
                overflowX: 'auto',
                scrollSnapType: 'x mandatory',
                whiteSpace: 'nowrap',
                // maxHeight: '85vh',
                height: '100%',
            }}>
                <div style={{
                    display: 'flex',
                    // height: '100vh',
                    height: '100%',
                }}>
                    <div style={{
                        // minWidth: '200px',
                        width: 'fit-content',
                        overflowX: 'scroll'
                    }}>
                        <table style={{ margin:'15px 0px 15px 15px', borderCollapse: 'collapse' }}>
                            <tr style={{height:'50px'}}>
                                <th colSpan={4}></th>
                                <th colSpan="100%">
                                    <div style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                    }}>
                                        <Select
                                            searchable={false}
                                            style={{width:'180px'}}
                                            value={quarter}
                                            onChange={setQuarter}
                                            data={getQuarters().map(q => {
                                                return { value: q, label: `Targets: ${q}` }
                                            })}
                                        ></Select>
                                        {isUpdatedAny ? <Button
                                            onClick={() => updateAgents(updates).then(()=>setUpdates({}))}
                                            disabled={isUploadingAny}
                                            leftIcon={<AiOutlineCloudUpload size={16} />}
                                            // style={{backgroundColor:hotPink}}
                                            variant='outline'
                                            color='dark'
                                        >
                                            Update All
                                        </Button> : ''}
                                    </div>
                                </th>
                            </tr>
                            <tr style={{
                                height:'30px',
                                borderBottom: 'black solid 1px',
                                position: 'sticky',
                                top: '0px',
                                zIndex: 99,
                            }}>
                                <th style={{ minWidth: '130px', width: '130px', paddingLeft:'25px', ...sticky, borderRight: 'black solid 1px'}}><div style={{display:'flex'}}>
                                    Name
                                    <ActionIcon
                                        style={{ margin: '0 0 0 5px' }}
                                        onClick={() => setExpandDetails(!expandDetails)}
                                    >
                                    <AiOutlineArrowRight size={16} style={{ transition: 'transform 0.2s', transform: expandDetails ? 'rotate(180deg)' : '' }} />
                                    </ActionIcon>
                                </div></th>
                                {/* <th style={{...foldy(expandDetails,'300px') }}>Email</th> */}
                                <th style={{paddingLeft:'10px', ...foldy(expandDetails,'100px') }}><Tooltip label="Teams containing an asterisk (*) are visible to all agents"><div>Teams</div></Tooltip></th>
                                <th style={{paddingLeft:'10px', ...foldy(expandDetails,'100px') }}>Manages</th>
                                <th style={{paddingLeft:'10px', borderRight: 'black solid 1px', ...foldy(expandDetails, '60px')}}>Type</th>
                                {days.map((d,i)=>{
                                    const today = isThisWeek(d)
                                    const color = isThisWeek(d) ? 'lightYellow' : 'unset' // (isFuture(d) ? 'lightblue' : 'unset')
                                    return (<th key={i} id={today?'this-week':''} style={{fontWeight:'lighter',backgroundColor:color, backgroundClip: 'content-box'}}>
                                        <div style={{margin: '0 10px'}}>
                                            {YYYYMMDD_AEDT(new Date(d))}
                                        </div>
                                    </th>)
                                })}
                            </tr>

                            {team?.agents.map((agent,i)=>{
                                const updated = isUpdated(agent, updates[agent?.email]??{})
                                const updating = isUploading[agent?.email]
                                return (<tr key={i} style={{height:'60px', transition: 'color 0.3s ease', backgroundColor: updated ? 'lightgreen' : i%2 ? 'unset' : 'rgba(0,0,0,0.05)'}}>
                                    <TeamOrganisationRow key={i} agent={agent} updateAgent={updateAgent} expandDetails={expandDetails} quarter={quarter} isUploading={updating} isUpdated={updated} updateTeam={updateTeam}/>
                                    <TeamTargetsRow agent={agent} startOfThisWeek={startOfThisWeek} quarter={quarter}/>
                                </tr>)
                            })}
                        </table>
{/*                         
                        <table style={{borderCollapse: 'collapse',margin: '15px 15px 15px 0px'}}>
                            <tr style={{height:'50px'}}>
                                <th colSpan="100%">
                                    <div style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                    }}>
                                        <Select
                                            searchable={false}
                                            style={{width:'180px'}}
                                            value={quarter}
                                            onChange={setQuarter}
                                            data={getQuarters().map(q => {
                                                return { value: q, label: `Targets: ${q}` }
                                            })}
                                        ></Select>
                                    </div>
                                </th>
                            </tr>
                            <tr style={{height:'30px', borderBottom: '1px solid black'}}>
                                {days.map((d,i)=>{
                                    const today = isThisWeek(d)
                                    const color = isThisWeek(d) ? 'lightYellow' : 'unset' // (isFuture(d) ? 'lightblue' : 'unset')
                                    return (<th key={i} id={today?'this-week':''} style={{fontWeight:'lighter',backgroundColor:color}}>
                                        <div style={{margin: '0 10px'}}>
                                            {YYYYMMDD_AEDT(new Date(d))}
                                        </div>
                                    </th>)
                                })}
                            </tr>
                            {team?.agents.map((t,i)=>{
                                // const T = {targets:[], ...t, ...updates[t?.email]}
                                return <TeamTargetsRow agent={t} startOfThisWeek={startOfThisWeek} quarter={quarter}/>
                            })}
                        </table> */}
                    </div>
                </div>

            </div>
        </ErrorBoundary>}
    </>} />)
}
